import * as Yup from 'yup';
import { PRIVILEGES } from 'utils/globalConst';
import messages from 'containers/SignupPages/AuthByContract/messages';
import { translate } from 'helpers/intl';

export default (props: any) =>
  Yup.object().shape({
    typeAssurance: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    numPolice: Yup.string()
      .notRequired()
      .when('typeAssurance', {
        is: (typeAssurance) => {
          return (
            typeAssurance === PRIVILEGES.AUTO ||
            typeAssurance === PRIVILEGES.MRH
          );
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    dateEffet: Yup.string()
      .notRequired()
      .when('typeAssurance', {
        is: (typeAssurance) => {
          return (
            typeAssurance === PRIVILEGES.AUTO ||
            typeAssurance === PRIVILEGES.MRH ||
            typeAssurance === PRIVILEGES.ASI
          );
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
  });
